import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifi3BarLock = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M13.667 8a1.65 1.65 0 0 1 1.666 1.667v1c.334 0 .667.333.667.666V14c0 .333-.333.667-.667.667H12c-.333 0-.667-.334-.667-.667v-2.667c0-.333.334-.666.667-.666v-1A1.65 1.65 0 0 1 13.667 8M2.333 7.267l.044-.028-2.11-2.572C.533 4.467 3.533 2 8 2s7.467 2.467 7.733 2.667l-1.4 1.8c-.2-.067-.4-.067-.666-.067-.2 0-.4 0-.6.067-.2 0-.334.066-.534.133-1.266.467-2.2 1.667-2.2 3.133v1.734L8 14.333Zm11.334 1.4c-.534 0-1 .466-1 1v1h2v-1c0-.534-.467-1-1-1"
        opacity={0.3}
      />
    </g>
  </svg>
)
export default SvgSignalWifi3BarLock
